var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPosts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 160,
    viewBox: "0 0 158 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5510_20250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.899 67.6163C107.413 71.2699 111.558 75.6126 111.558 75.6126C105.241 76.0456 101.82 72.5907 100.348 70.4914C98.5284 71 96.658 71.321 94.7682 71.4492C81.8 72.3381 70.6363 64.1498 69.8301 53.1508C69.0238 42.1518 78.8818 32.5222 91.8501 31.6334C104.818 30.7446 115.981 38.9324 116.787 49.9316C117.312 57.0861 113.32 63.6622 106.899 67.6163Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.3081 55.3149C95.0888 55.3149 96.5324 53.9188 96.5324 52.1965C96.5324 50.4743 95.0888 49.0781 93.3081 49.0781C91.5273 49.0781 90.0837 50.4743 90.0837 52.1965C90.0837 53.9188 91.5273 55.3149 93.3081 55.3149Z",
    fill: "#4E7E77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8734 53.9551C80.6649 53.9551 82.1172 52.5505 82.1172 50.8179C82.1172 49.0852 80.6649 47.6807 78.8734 47.6807C77.0819 47.6807 75.6296 49.0852 75.6296 50.8179C75.6296 52.5505 77.0819 53.9551 78.8734 53.9551Z",
    fill: "#4E7E77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.605 56.6435C109.397 56.6435 110.849 55.2389 110.849 53.5063C110.849 51.7737 109.397 50.3691 107.605 50.3691C105.814 50.3691 104.361 51.7737 104.361 53.5063C104.361 55.2389 105.814 56.6435 107.605 56.6435Z",
    fill: "#4E7E77"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7 82.7429L93.114 96.1705L80.7966 160.001L58.6086 155.994L72.8354 82.2588L73.5119 78.7451L95.7 82.7429Z",
    fill: "#4E7E77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.344 50.6304L142.693 90.3C142.671 90.4162 142.625 90.5271 142.558 90.6262C142.491 90.7254 142.405 90.8108 142.304 90.8776C142.203 90.9445 142.09 90.9915 141.97 91.0159C141.851 91.0403 141.727 91.0417 141.607 91.0199L34.1191 71.6312L46.7705 6.02832L128.392 20.7516C143.186 23.4195 153.012 36.794 150.344 50.6304Z",
    fill: "#81B1AA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7287 37.3187L62.1378 76.6804L5.71704 66.5032L13.3078 27.1415C16.1027 12.6491 30.999 3.17862 46.5789 5.9889C62.1588 8.79918 72.5236 22.826 69.7287 37.3187Z",
    fill: "#4E7E77"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9949 55.7188C91.8371 54.9688 89.0939 51.0607 89.8768 47.0023C90.6598 42.9439 94.6748 40.2541 98.8325 41.0045C100.158 41.2453 101.394 41.8213 102.414 42.6739C103.435 43.5265 104.204 44.6253 104.643 45.8585L157.162 55.3321L155.743 62.6894L103.224 53.2159C102.355 54.2133 101.228 54.9704 99.9583 55.41C98.6885 55.8497 97.321 55.9562 95.9949 55.7188V55.7188Z",
    fill: "#34544F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8568 38.0422L60.461 76.3922L7.31055 66.8049L14.7069 28.4546C17.4298 14.3349 31.5358 5.03414 46.2128 7.68163C60.8897 10.3291 70.5797 23.9222 67.8568 38.0422Z",
    fill: "#34544F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4843 52.0029C99.6212 52.0029 101.354 50.3275 101.354 48.2607C101.354 46.194 99.6212 44.5186 97.4843 44.5186C95.3473 44.5186 93.615 46.194 93.615 48.2607C93.615 50.3275 95.3473 52.0029 97.4843 52.0029Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M157.769 55.3066L153.13 79.3632C153.11 79.4668 153.048 79.5585 152.958 79.6181C152.869 79.6777 152.758 79.7003 152.651 79.6809L140.455 77.4811C140.434 77.4773 140.416 77.4655 140.403 77.4484C140.391 77.4312 140.387 77.4101 140.391 77.3896L145.09 53.0195C145.094 52.9991 145.107 52.981 145.124 52.9692C145.142 52.9575 145.164 52.953 145.185 52.9568L157.704 55.2151C157.726 55.2189 157.744 55.2307 157.756 55.2479C157.769 55.265 157.773 55.2862 157.769 55.3066V55.3066Z",
    fill: "#4E7E77"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2849 76.1885C60.3273 75.4321 63.6239 63.4237 65.5799 49.8978C73.2849 24.6885 63.2849 8.18848 42.08 7.40901C18.7849 8.68847 15.2216 23.1881 12.5799 38.1721C10.285 51.1887 7.07993 66.7968 7.07993 66.7968L60.2849 76.1885Z",
    fill: "#3B5F59"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7001 82.7429L93.1141 96.1705L72.8354 82.2588L73.5119 78.7451L95.7001 82.7429Z",
    fill: "#34544F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5510_20250",
    x: 65.7839,
    y: 29.5674,
    width: 55.0493,
    height: 52.082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.659931 0 0 0 0 0.648403 0 0 0 0 0.648403 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5510_20250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5510_20250",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosts);
export default __webpack_public_path__ + "static/media/posts.0ee8d601957108eabcafdbb05f407e90.svg";
export { ForwardRef as ReactComponent };